import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VersionService } from '@core/services/version/version.service';
import { switchMap } from 'rxjs/operators';
import { TypeUtilService } from '../core/services/utils/type-util.service';
import { environment } from '@src/environments/environment';

@Injectable()

export class XAppVersionInterceptor implements HttpInterceptor {
  constructor(
    private readonly versionService: VersionService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(!this.versionService) return next.handle(req);
    return this.versionService.getVersion()
      .pipe(
        switchMap((version: string | string[]) => {
          const isPWA = TypeUtilService.isTruthy(environment?.pwa?.enabled);
          if (isPWA) {
            version = `${version} (PWA)`;
          }

          const xAppVersionHeader = req.clone({
            headers: req.headers.set('X-App-Version', version)
          });
          return next.handle(xAppVersionHeader);
        })
      )
  }

}
